import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Logo } from "./Logo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  ["lineup", "Lineup"],
  ["experience", "Experience"],
  ["venue", "Visit"],
  ["packages", "Packages"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (pathname === "/") scrollToId(id);
    else navigate(`/#${id}`);
  };

  return (
    <header
      data-testid="nav-header"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${scrolled || open ? "bg-[#0B0C10]/85 backdrop-blur-xl border-b border-white/5" : "bg-transparent"}`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-12">
        <Link to="/" data-testid="nav-logo-link" aria-label="Fallsview Summer Concert Series home"><Logo /></Link>
        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)} className="nav-link font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 hover:text-white">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span className="hidden sm:block"><button data-testid="nav-get-tickets-btn" onClick={() => go("lineup")} className="btn-primary">Get Tickets</button></span>
          <button data-testid="nav-mobile-toggle" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} onClick={() => setOpen(!open)} className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-white lg:hidden">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-white/5 lg:hidden"
            aria-label="Mobile"
          >
            <div className="flex flex-col px-5 py-6">
              {LINKS.map(([id, label]) => (
                <button key={id} data-testid={`mobile-nav-link-${id}`} onClick={() => go(id)} className="border-b border-white/5 py-4 text-left font-display text-3xl font-bold uppercase text-white">
                  {label}
                </button>
              ))}
              <button data-testid="mobile-nav-get-tickets-btn" onClick={() => go("lineup")} className="btn-primary mt-6 justify-center">Get Tickets</button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
